import { computed } from "vue";
import { createFileUploadItem } from "../utils/fileUploadItem";
import type { DSFileUploadComponentProps, DSFileUploadEmits, DSFileUploadItem, DSFileUploadModelValue } from "../types";

interface UseDSFileUploadModelOptions {
  props: DSFileUploadComponentProps;
  emit: DSFileUploadEmits;
}

export function useDSFileUploadModel({ props, emit }: UseDSFileUploadModelOptions) {
  const modelValue = computed<DSFileUploadModelValue>({
    get: () => props.modelValue ?? [],
    set: value => {
      emit("update:modelValue", value);
    },
  });

  function addAcceptedFiles(accepted: File[], event: Event | DragEvent): DSFileUploadModelValue | undefined {
    if (!accepted.length) return undefined;

    const acceptedItems = accepted.map(createFileUploadItem);
    const nextModelValue = props.multiple ? [...modelValue.value, ...acceptedItems] : acceptedItems.slice(0, 1);
    emit("select", accepted, event);
    modelValue.value = nextModelValue;

    return nextModelValue;
  }

  function removeFile(item: DSFileUploadItem): DSFileUploadModelValue | undefined {
    if (props.disabled) return undefined;

    const nextModelValue = modelValue.value.filter(file => file.id !== item.id);
    emit("remove", item);
    modelValue.value = nextModelValue;

    return nextModelValue;
  }

  function removeAllFiles(): DSFileUploadModelValue | undefined {
    if (props.disabled) return undefined;

    emit("remove-all");
    modelValue.value = [];

    return [];
  }

  return {
    addAcceptedFiles,
    modelValue,
    removeAllFiles,
    removeFile,
  };
}
